import { useEffect, useState } from 'react';

/*
  useResolvedColors — вычисляет реальные значения семантических токенов (`--fg`, `--card` …)
  в текущей теме через скрытый элемент и getComputedStyle. Нужен галерее для живого
  расчёта контраста (R15): значения берутся из CSS, а не дублируются в JS.

  Измерение откладывается на кадр: ThemeProvider ставит data-theme в своём эффекте,
  который выполняется после эффектов детей.
*/
export function useResolvedColors(names: readonly string[], themeKey: string): Record<string, string> {
  const [map, setMap] = useState<Record<string, string>>({});
  const key = names.join('|');

  useEffect(() => {
    let cancelled = false;
    const frame = requestAnimationFrame(() => {
      const probe = document.createElement('div');
      probe.style.position = 'absolute';
      probe.style.visibility = 'hidden';
      probe.style.pointerEvents = 'none';
      document.body.appendChild(probe);
      const out: Record<string, string> = {};
      for (const name of key.split('|')) {
        probe.style.backgroundColor = `var(--${name})`;
        out[name] = getComputedStyle(probe).backgroundColor;
      }
      probe.remove();
      if (!cancelled) setMap(out);
    });
    return () => {
      cancelled = true;
      cancelAnimationFrame(frame);
    };
  }, [key, themeKey]);

  return map;
}
